import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormVariantSelectorComponent } from './form-variant-selector.component';

/**
 * Module wrapper for the fill-time variant selector so each form-fill module (session-form-
 * page-steps, program-form-page-steps, etc.) can import and use it with a single import.
 */
@NgModule({
  declarations: [FormVariantSelectorComponent],
  imports: [CommonModule, FormsModule, NgSelectModule],
  exports: [FormVariantSelectorComponent],
})
export class FormVariantSelectorModule {}
